export class Mappable {
  static map() {
    throw new Error('Mappable.map not implemented');
  }
}
